import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const whoop = defineConnector({
  identifier: "whoop",
  name: "Whoop",
  tagLine: "Fitness and recovery wearable",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.prod\\.whoop\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Whoop app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [WHOOP Developer Portal](https://developer-dashboard.whoop.com/) and create a new application. You'll receive a client ID and secret after registering.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/whoop/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Whoop account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Whoop account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.prod.whoop.com/oauth/oauth2/auth",
    tokenEndpoint: () => "https://api.prod.whoop.com/oauth/oauth2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.prod.whoop.com/developer/v1/user/profile/basic",
  },
});
